import IMobGenerate from "./IMobGenerate";

export default class Level {
    public Name: string;
    public Difficulty: string;
    // The gold earned by winning level
    public GoldEarn: number;
    // The Exp earned by winning level
    public ExpEarn:number;

    public DurationLimitMinutes: number;
    public StopLevelWhenTimeout: boolean;
    public Background: string;

    public Generators: IMobGenerate[];

    static CreateLevel(name: string,
        generators: IMobGenerate[],
        durationMinues: number,
        difficulty: string,
        goldEarn: number,
        expEarn: number,
        background: string,
        shouldStopLevel: boolean) {

        let level = new Level();

        level.Name = name;
        level.Difficulty = difficulty;
        level.GoldEarn = goldEarn;
        level.ExpEarn = expEarn;
        level.Background = background;
        level.DurationLimitMinutes = durationMinues;
        level.StopLevelWhenTimeout = shouldStopLevel;
        level.Generators = generators;

        return level;
    }
}